// import React, { useEffect, useState, useRef } from 'react';
// import './Profile.css'; // Import the CSS file
 
// // --- SVG Icons defined directly in the file ---
// const IconUpload = () => (
//     <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//         <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
//         <polyline points="17 8 12 3 7 8"></polyline>
//         <line x1="12" y1="3" x2="12" y2="15"></line>
//     </svg>
// );
 
// const IconDelete = () => (
//     <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//         <polyline points="3 6 5 6 21 6"></polyline>
//         <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
//         <line x1="10" y1="11" x2="10" y2="17"></line>
//         <line x1="14" y1="11" x2="14" y2="17"></line>
//     </svg>
// );
 
 
// // --- Configuration ---
// const USER_DETAILS_KEY = 'zTaskUserDetails';
// const AUTH_TOKEN_KEY = 'zTaskAuthToken';
// const API_BASE_URL = process.env.REACT_APP_SWAGGER_SERVICE_BASE_URL;
 
// // --- API Helpers ---
 
// const getAuthToken = () => {
//     const token = localStorage.getItem(AUTH_TOKEN_KEY);
//     if (!token) {
//         throw new Error("Authentication token not found.");
//     }
//     return token;
// };
 
// // =================================================================================
// // ### UPDATED AND CORRECTED FUNCTION ###
// // This is the section that has been fixed to solve the error.
// // =================================================================================
// const updateUserProfileAPI = async (userId, newName) => {
//     const token = getAuthToken();
   
//     // 1. Correct URL: Use the endpoint from Swagger docs and add parameters as query strings.
//     const url = `${API_BASE_URL}/api/update-user-name?name=${encodeURIComponent(newName)}&userId=${userId}`;
 
//     const response = await fetch(url, {
//         // 2. Correct Method: Changed from 'PATCH' to 'PUT'.
//         method: 'PUT',
//         headers: {
//             // 3. Correct Headers: Removed 'Content-Type' as there is no JSON body.
//             'Authorization': `Bearer ${token}`
//         }
//         // 4. Correct Data Submission: Removed the 'body' attribute.
//     });
 
//     if (!response.ok) {
//         const errorData = await response.json().catch(() => ({ message: 'Failed to update profile.' }));
//         throw new Error(errorData.message || 'An unknown server error occurred.');
//     }
 
//     return response.json();
// };
// // =================================================================================
// // ### END OF CORRECTED SECTION ###
// // =================================================================================
 
 
// const getProfileImageAPI = async (userId) => {
//     const token = getAuthToken();
//     const response = await fetch(`${API_BASE_URL}/api/get-profile-image?userId=${userId}`, {
//         headers: {
//             'Authorization': `Bearer ${token}`
//         }
//     });
 
//     if (!response.ok) {
//         if (response.status === 401 || response.status === 404) {
//             return null;
//         }
//         const errorData = await response.json().catch(() => ({ message: 'Failed to fetch profile image.' }));
//         throw new Error(errorData.message || 'An unknown server error occurred.');
//     }
   
//     const data = await response.json();
 
//     if (data && data.message && data.message.image && data.message.id) {
//         const base64String = data.message.image;
//         const imageId = data.message.id;
//         const imageUrl = `data:image/jpeg;base64,${base64String}`;
 
//         return {
//             url: imageUrl,
//             id: imageId
//         };
//     } else {
//         console.warn("Profile image response was successful but the JSON format was unexpected.");
//         return null;
//     }
// };
 
 
// const createProfileImageAPI = async (userId, imageFile) => {
//     const token = getAuthToken();
//     const formData = new FormData();
//     formData.append('imageFile', imageFile);
 
//     const response = await fetch(`${API_BASE_URL}/api/set-profile-image?userId=${userId}`, {
//         method: 'POST',
//         headers: {
//             'Authorization': `Bearer ${token}`
//         },
//         body: formData
//     });
 
//     if (!response.ok) {
//         const errorData = await response.json().catch(() => ({ message: 'Failed to create profile image.' }));
//         throw new Error(errorData.message || 'An unknown server error occurred.');
//     }
 
//     return response.json();
// };
 
// const updateProfileImageAPI = async (profileImageId, imageFile) => {
//     const token = getAuthToken();
//     const formData = new FormData();
//     formData.append('imageFile', imageFile);
 
//     const response = await fetch(`${API_BASE_URL}/api/update-profile-image?profileImageId=${profileImageId}`, {
//         method: 'PATCH',
//         headers: {
//             'Authorization': `Bearer ${token}`
//         },
//         body: formData
//     });
 
//     if (!response.ok) {
//         const errorData = await response.json().catch(() => ({ message: 'Failed to update profile image.' }));
//         throw new Error(errorData.message || 'An unknown server error occurred.');
//     }
 
//     return response.json();
// };
 
// const deleteProfileImageAPI = async (profileImageId) => {
//     const token = getAuthToken();
//     const response = await fetch(`${API_BASE_URL}/api/delete-profile-image?profileImageId=${profileImageId}`, {
//         method: 'DELETE',
//         headers: {
//             'Authorization': `Bearer ${token}`,
//             'Content-Type': 'application/json'
//         }
//     });
 
//     if (!response.ok) {
//         const errorData = await response.json().catch(() => ({ message: 'Failed to delete profile image.' }));
//         throw new Error(errorData.message || 'An unknown server error occurred.');
//     }
 
//     return response.json();
// };
 
 
// const Profile = () => {
//   const [currentUserDetails, setCurrentUserDetails] = useState(null);
//   const [fullNameInput, setFullNameInput] = useState('');
//   const [avatarInitials, setAvatarInitials] = useState('');
//   const [profileImage, setProfileImage] = useState(null);
//   const [profileImageId, setProfileImageId] = useState(null);
//   const [isImageLoading, setIsImageLoading] = useState(true);
//   const [isSaving, setIsSaving] = useState(false);
//   const [isUploading, setIsUploading] = useState(false);
//   const [isDeleting, setIsDeleting] = useState(false);
//   const [errorMessage, setErrorMessage] = useState('');
//   const [successMessage, setSuccessMessage] = useState('');
//   const fileInputRef = useRef(null);
 
 
//   useEffect(() => {
//     let userDetails = null;
 
//     try {
//       const storedUserDetailsString = localStorage.getItem(USER_DETAILS_KEY);
//       if (storedUserDetailsString) {
//         userDetails = JSON.parse(storedUserDetailsString);
//         setCurrentUserDetails(userDetails);
//         setFullNameInput(userDetails.name || '');
 
//         if (userDetails.name) {
//           const nameParts = userDetails.name.trim().split(' ');
//           let initials = nameParts[0] ? nameParts[0][0] : '';
//           if (nameParts.length > 1 && nameParts[nameParts.length - 1]) {
//             initials += nameParts[nameParts.length - 1][0];
//           }
//           setAvatarInitials(initials.toUpperCase());
//         } else if (userDetails.email) {
//             setAvatarInitials(userDetails.email[0].toUpperCase());
//         } else {
//             setAvatarInitials('?');
//         }
//       } else {
//         setErrorMessage("User details not found. Please log in again.");
//         setIsImageLoading(false);
//         return;
//       }
//     } catch (e) {
//         console.error("Profile: Failed to parse userDetails from localStorage:", e);
//         setErrorMessage("Could not load user profile. Data might be corrupted.");
//         setIsImageLoading(false);
//         return;
//     }
 
//     const fetchImage = async () => {
//         if (!userDetails || !userDetails.id) {
//             setIsImageLoading(false);
//             return;
//         }
//         setIsImageLoading(true);
//         try {
//             const imageData = await getProfileImageAPI(userDetails.id);
//             if (imageData) {
//                 setProfileImage(imageData.url);
//                 setProfileImageId(imageData.id);
//             }
//         } catch (apiError) {
//             console.error("Profile: Failed to fetch profile image:", apiError);
//             setErrorMessage("Could not load profile image from the server.");
//         } finally {
//             setIsImageLoading(false);
//         }
//     };
   
//     fetchImage();
//   }, []);
 
//   const handleFullNameChange = (e) => {
//     setFullNameInput(e.target.value);
//   };
 
//   const handleSaveChanges = async (e) => {
//     e.preventDefault();
//     setSuccessMessage('');
//     setErrorMessage('');
//     setIsSaving(true);
 
//     if (!fullNameInput.trim()) {
//       setErrorMessage("Full Name cannot be empty.");
//       setIsSaving(false);
//       return;
//     }
//     if (!currentUserDetails || !currentUserDetails.id) {
//         setErrorMessage("User session error. Cannot save changes.");
//         setIsSaving(false);
//         return;
//     }
 
//     try {
//         const trimmedName = fullNameInput.trim();
//         await updateUserProfileAPI(currentUserDetails.id, trimmedName);
       
//         const updatedUserDetails = {
//             ...currentUserDetails,
//             name: trimmedName
//         };
//         localStorage.setItem(USER_DETAILS_KEY, JSON.stringify(updatedUserDetails));
       
//         setCurrentUserDetails(updatedUserDetails);
 
//          if (updatedUserDetails.name) {
//           const nameParts = updatedUserDetails.name.trim().split(' ');
//           let initials = nameParts[0] ? nameParts[0][0] : '';
//           if (nameParts.length > 1 && nameParts[nameParts.length - 1]) {
//             initials += nameParts[nameParts.length - 1][0];
//           }
//           setAvatarInitials(initials.toUpperCase());
//         }
       
//         window.dispatchEvent(new Event('profileUpdated'));
 
//         setSuccessMessage('Profile updated successfully!');
//         setTimeout(() => setSuccessMessage(''), 3000);
 
//     } catch (apiError) {
//         console.error("Error updating profile:", apiError);
//         setErrorMessage(apiError.message || "Failed to update profile. Please try again.");
//     } finally {
//         setIsSaving(false);
//     }
//   };
 
//   const handleAvatarClick = () => {
//       fileInputRef.current.click();
//   };
 
//   const handleFileSelected = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
 
//     setIsUploading(true);
//     setSuccessMessage('');
//     setErrorMessage('');
 
//     try {
//         let newImageId = profileImageId;
//         if (profileImageId) {
//             await updateProfileImageAPI(profileImageId, file);
//         } else {
//             const response = await createProfileImageAPI(currentUserDetails.id, file);
//             newImageId = response.profileImageId;
//         }
       
//         setProfileImage(URL.createObjectURL(file));
//         setProfileImageId(newImageId);
//         setSuccessMessage('Avatar updated successfully!');
//         setTimeout(() => setSuccessMessage(''), 3000);
 
//     } catch (apiError) {
//         console.error("Error uploading avatar:", apiError);
//         setErrorMessage(apiError.message || "Failed to upload avatar. Please try again.");
//     } finally {
//         setIsUploading(false);
//         e.target.value = null;
//     }
//   };
 
//   const handleRemoveAvatar = async () => {
//     if (!profileImageId) {
//         setErrorMessage("Cannot remove: Profile image ID is missing.");
//         return;
//     }
 
//     setIsDeleting(true);
//     setSuccessMessage('');
//     setErrorMessage('');
 
//     try {
//         await deleteProfileImageAPI(profileImageId);
//         setProfileImage(null);
//         setProfileImageId(null);
//         setSuccessMessage('Avatar removed successfully!');
//         setTimeout(() => setSuccessMessage(''), 3000);
//     } catch (apiError) {
//         console.error("Error removing avatar:", apiError);
//         setErrorMessage(apiError.message || "Failed to remove avatar. Please try again.");
//     } finally {
//         setIsDeleting(false);
//     }
//   };
 
//   if (errorMessage && !currentUserDetails) {
//     return <div className="profile-error-critical">{errorMessage}</div>;
//   }
 
//   return (
//     <div className="profile-page-container">
//       <div className="profile-main-panel">
//         <div className="profile-section personal-information">
//           <h2>Personal Information</h2>
//           <p className="section-subtitle">
//             Update your personal details.
//             {currentUserDetails && currentUserDetails.role && currentUserDetails.role.name && (
//               <span className="user-role-display-inline">
//                 Your Role: <span className="role-badge">{currentUserDetails.role.name.replace(/_/g, ' ')}</span>
//               </span>
//             )}
//           </p>
 
//           {errorMessage && <div className="profile-message error-message">{errorMessage}</div>}
//           {successMessage && <div className="profile-message success-message">{successMessage}</div>}
 
//           {currentUserDetails ? (
//             <form onSubmit={handleSaveChanges}>
//               <div className="form-group">
//                 <label htmlFor="fullName">Full Name</label>
//                 <input
//                   type="text"
//                   id="fullName"
//                   name="fullName"
//                   value={fullNameInput}
//                   onChange={handleFullNameChange}
//                   disabled={isSaving}
//                 />
//               </div>
//               <div className="form-group">
//                 <label htmlFor="emailOrUsername">Email or Username</label>
//                 <input
//                   type="text"
//                   id="emailOrUsername"
//                   name="emailOrUsername"
//                   value={currentUserDetails.email || ''}
//                   readOnly
//                   disabled
//                   title="This value cannot be changed."
//                 />
//                 <small className="form-note">Email and Username cannot be changed.</small>
//               </div>
//               <button type="submit" className="profile-button profile-button-primary" disabled={isSaving}>
//                 {isSaving ? 'Saving...' : 'Save Changes'}
//               </button>
//             </form>
//           ) : (
//             <div className="profile-loading">Loading profile...</div>
//           )}
//         </div>
//       </div>
 
//       {currentUserDetails && (
//         <div className="profile-sidebar-panel">
//           <div className="profile-section avatar-section">
//             <h3>Your Avatar</h3>
//             <div className="avatar-container">
//                 <div className="avatar-display" title="Current Avatar">
//                     {isImageLoading ? (
//                          <div className="avatar-overlay">Loading...</div>
//                     ) : profileImage ? (
//                         <img src={profileImage} alt="Profile Avatar" className="profile-avatar-image" />
//                     ) : (
//                         avatarInitials || '?'
//                     )}
//                     {(isUploading || isDeleting) && <div className="avatar-overlay">{isUploading ? 'Uploading...' : 'Deleting...'}</div>}
//                 </div>
//             </div>
           
//             <div className="avatar-actions">
//                 <button
//                     type="button"
//                     className="avatar-action-button upload-button"
//                     title="Upload New Avatar"
//                     onClick={handleAvatarClick}
//                     disabled={isUploading || isDeleting || isImageLoading}
//                 >
//                     <IconUpload />
//                 </button>
//                 <button
//                     type="button"
//                     className="avatar-action-button delete-button"
//                     title="Remove Avatar"
//                     onClick={handleRemoveAvatar}
//                     disabled={!profileImageId || isUploading || isDeleting || isImageLoading}
//                 >
//                     <IconDelete />
//                 </button>
//             </div>
 
//             <input
//                 type="file"
//                 ref={fileInputRef}
//                 onChange={handleFileSelected}
//                 style={{ display: 'none' }}
//                 accept="image/png, image/jpeg, image/gif"
//             />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };
 
// export default Profile;








import React, { useEffect, useState, useRef } from 'react';
import './Profile.css'; // Make sure you have this CSS file for styling

// --- SVG Icons (defined directly in the file for simplicity) ---
const IconUpload = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
        <polyline points="17 8 12 3 7 8"></polyline>
        <line x1="12" y1="3" x2="12" y2="15"></line>
    </svg>
);

const IconDelete = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="3 6 5 6 21 6"></polyline>
        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
        <line x1="10" y1="11" x2="10" y2="17"></line>
        <line x1="14" y1="11" x2="14" y2="17"></line>
    </svg>
);


// --- Configuration ---
const USER_DETAILS_KEY = 'zTaskUserDetails';
const AUTH_TOKEN_KEY = 'zTaskAuthToken';
// Ensure you have REACT_APP_SWAGGER_SERVICE_BASE_URL in your .env file
const API_BASE_URL = process.env.REACT_APP_SWAGGER_SERVICE_BASE_URL;
const AUTH_APP_URL = process.env.REACT_APP_ZTOOL_URL || 'http://localhost:3000';
const CHANGE_PASSWORD_ENDPOINT = `${API_BASE_URL}/api/change-password`;

// --- API Helpers ---

const getAuthToken = () => {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    if (!token) {
        // It's better to handle this gracefully, e.g., by redirecting to login
        console.error("Authentication token not found.");
        throw new Error("Authentication token not found.");
    }
    return token;
};

const updateUserProfileAPI = async (userId, newName) => {
    const token = getAuthToken();
    const url = `${API_BASE_URL}/api/update-user-name?name=${encodeURIComponent(newName)}&userId=${userId}`;

    const response = await fetch(url, {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: 'Failed to update profile.' }));
        throw new Error(errorData.message || 'An unknown server error occurred.');
    }
    return response.json();
};

// =================================================================================
// ### KEY FUNCTION FOR FETCHING IMAGE ###
// This function now correctly expects `data.message.id` from your API response.
// =================================================================================
const getProfileImageAPI = async (userId) => {
    const token = getAuthToken();
    const response = await fetch(`${API_BASE_URL}/api/get-profile-image?userId=${userId}`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });

    if (!response.ok) {
        // If no image is found (404) or user is unauthorized (401), return null gracefully.
        if (response.status === 404 || response.status === 401) {
            return null;
        }
        const errorData = await response.json().catch(() => ({ message: 'Failed to fetch profile image.' }));
        throw new Error(errorData.message || 'An unknown server error occurred.');
    }
    
    const data = await response.json();

    // This check is crucial. It looks for the 'id' field in the response.
    if (data && data.message && data.message.image && data.message.id) {
        const base64String = data.message.image;
        const imageId = data.message.id; // The ID for the delete button
        const imageUrl = `data:image/jpeg;base64,${base64String}`;

        return {
            url: imageUrl,
            id: imageId
        };
    } else {
        // This handles cases where the user has an image but the API response is malformed.
        console.warn("Profile image response was successful but the JSON format was unexpected.");
        return null;
    }
};

const createProfileImageAPI = async (userId, imageFile) => {
    const token = getAuthToken();
    const formData = new FormData();
    formData.append('imageFile', imageFile);

    const response = await fetch(`${API_BASE_URL}/api/set-profile-image?userId=${userId}`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData
    });

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: 'Failed to create profile image.' }));
        throw new Error(errorData.message || 'An unknown server error occurred.');
    }
    return response.json();
};

const updateProfileImageAPI = async (profileImageId, imageFile) => {
    const token = getAuthToken();
    const formData = new FormData();
    formData.append('imageFile', imageFile);

    const response = await fetch(`${API_BASE_URL}/api/update-profile-image?profileImageId=${profileImageId}`, {
        method: 'PATCH',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData
    });

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: 'Failed to update profile image.' }));
        throw new Error(errorData.message || 'An unknown server error occurred.');
    }
    return response.json();
};

// =================================================================================
// ### KEY FUNCTION FOR DELETING IMAGE ###
// This function requires `profileImageId` to work, which is why the button depends on it.
// =================================================================================
const deleteProfileImageAPI = async (profileImageId) => {
    const token = getAuthToken();
    const response = await fetch(`${API_BASE_URL}/api/delete-profile-image?profileImageId=${profileImageId}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
    });

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: 'Failed to delete profile image.' }));
        throw new Error(errorData.message || 'An unknown server error occurred.');
    }
    return response.json();
};


const Profile = () => {
  const [currentUserDetails, setCurrentUserDetails] = useState(null);
  const [fullNameInput, setFullNameInput] = useState('');
  const [avatarInitials, setAvatarInitials] = useState('');
  const [profileImage, setProfileImage] = useState(null);
  const [profileImageId, setProfileImageId] = useState(null); // This state controls the delete button
  const [isImageLoading, setIsImageLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const fileInputRef = useRef(null);

  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isChangingPassword, setIsChangingPassword] = useState(false);
  const [passwordMessage, setPasswordMessage] = useState({ text: '', type: '' });

  useEffect(() => {
    let userDetails = null;
    try {
      const storedUserDetailsString = localStorage.getItem(USER_DETAILS_KEY);
      if (storedUserDetailsString) {
        userDetails = JSON.parse(storedUserDetailsString);
        setCurrentUserDetails(userDetails);
        setFullNameInput(userDetails.name || '');

        // Logic to create avatar initials as a fallback
        if (userDetails.name) {
          const nameParts = userDetails.name.trim().split(' ');
          let initials = nameParts[0] ? nameParts[0][0] : '';
          if (nameParts.length > 1 && nameParts[nameParts.length - 1]) {
            initials += nameParts[nameParts.length - 1][0];
          }
          setAvatarInitials(initials.toUpperCase());
        } else if (userDetails.email) {
            setAvatarInitials(userDetails.email[0].toUpperCase());
        } else {
            setAvatarInitials('?');
        }
      } else {
        setErrorMessage("User details not found. Please log in again.");
        setIsImageLoading(false);
        return;
      }
    } catch (e) {
        console.error("Profile: Failed to parse userDetails from localStorage:", e);
        setErrorMessage("Could not load user profile. Data might be corrupted.");
        setIsImageLoading(false);
        return;
    }

    const fetchImage = async () => {
        if (!userDetails || !userDetails.id) {
            setIsImageLoading(false);
            return;
        }
        setIsImageLoading(true);
        try {
            const imageData = await getProfileImageAPI(userDetails.id);
            if (imageData && imageData.id) {
                setProfileImage(imageData.url);
                setProfileImageId(imageData.id); // **This is where the ID is set!**
            }
        } catch (apiError) {
            console.error("Profile: Failed to fetch profile image:", apiError);
            setErrorMessage("Could not load profile image from the server.");
        } finally {
            setIsImageLoading(false);
        }
    };
    
    fetchImage();
  }, []);

  const handleFullNameChange = (e) => setFullNameInput(e.target.value);

  const handleSaveChanges = async (e) => {
    e.preventDefault();
    setSuccessMessage('');
    setErrorMessage('');
    setIsSaving(true);

    if (!fullNameInput.trim()) {
      setErrorMessage("Full Name cannot be empty.");
      setIsSaving(false);
      return;
    }
    if (!currentUserDetails || !currentUserDetails.id) {
        setErrorMessage("User session error. Cannot save changes.");
        setIsSaving(false);
        return;
    }

    try {
        const trimmedName = fullNameInput.trim();
        await updateUserProfileAPI(currentUserDetails.id, trimmedName);
        
        const updatedUserDetails = { ...currentUserDetails, name: trimmedName };
        localStorage.setItem(USER_DETAILS_KEY, JSON.stringify(updatedUserDetails));
        
        setCurrentUserDetails(updatedUserDetails);

        // Update initials after name change
        if (updatedUserDetails.name) {
          const nameParts = updatedUserDetails.name.trim().split(' ');
          let initials = nameParts[0] ? nameParts[0][0] : '';
          if (nameParts.length > 1 && nameParts[nameParts.length - 1]) {
            initials += nameParts[nameParts.length - 1][0];
          }
          setAvatarInitials(initials.toUpperCase());
        }
        
        window.dispatchEvent(new Event('profileUpdated'));
        setSuccessMessage('Profile updated successfully!');
        setTimeout(() => setSuccessMessage(''), 3000);

    } catch (apiError) {
        console.error("Error updating profile:", apiError);
        setErrorMessage(apiError.message || "Failed to update profile. Please try again.");
    } finally {
        setIsSaving(false);
    }
  };

  const handleAvatarClick = () => fileInputRef.current.click();

  const handleFileSelected = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setIsUploading(true);
    setSuccessMessage('');
    setErrorMessage('');

    try {
        let response;
        if (profileImageId) {
            response = await updateProfileImageAPI(profileImageId, file);
        } else {
            response = await createProfileImageAPI(currentUserDetails.id, file);
        }
        
        // After upload/update, re-fetch the image to get the latest URL and ID
        const imageData = await getProfileImageAPI(currentUserDetails.id);
        if (imageData) {
            setProfileImage(imageData.url);
            setProfileImageId(imageData.id);
        }
        
        setSuccessMessage('Avatar updated successfully!');
        setTimeout(() => setSuccessMessage(''), 3000);

    } catch (apiError) {
        console.error("Error uploading avatar:", apiError);
        setErrorMessage(apiError.message || "Failed to upload avatar. Please try again.");
    } finally {
        setIsUploading(false);
        e.target.value = null; // Reset file input
    }
  };

  const handleRemoveAvatar = async () => {
    if (!profileImageId) {
        setErrorMessage("Cannot remove: No profile image is set.");
        return;
    }

    setIsDeleting(true);
    setSuccessMessage('');
    setErrorMessage('');

    try {
        await deleteProfileImageAPI(profileImageId);
        setProfileImage(null);
        setProfileImageId(null); // **Resetting the ID disables the delete button**
        setSuccessMessage('Avatar removed successfully!');
        setTimeout(() => setSuccessMessage(''), 3000);
    } catch (apiError) {
        console.error("Error removing avatar:", apiError);
        setErrorMessage(apiError.message || "Failed to remove avatar. Please try again.");
    } finally {
        setIsDeleting(false);
    }
  };
  
  const handleChangePassword = async (e) => {
    e.preventDefault();
    setPasswordMessage({ text: '', type: '' });
    if (!currentPassword || !newPassword) {
      setPasswordMessage({ text: 'Current and new password are required.', type: 'error' });
      return;
    }
    if (newPassword.length < 6) {
      setPasswordMessage({ text: 'New password must be at least 6 characters.', type: 'error' });
      return;
    }
    if (newPassword !== confirmPassword) {
      setPasswordMessage({ text: 'New password and confirmation do not match.', type: 'error' });
      return;
    }
    setIsChangingPassword(true);
    try {
      const token = getAuthToken();
      const response = await fetch(CHANGE_PASSWORD_ENDPOINT, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ currentPassword, newPassword }),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.message || 'Failed to change password');
      setPasswordMessage({ text: data.message || 'Password updated. Please log in again.', type: 'success' });
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err) {
      setPasswordMessage({ text: err.message || 'Failed to change password.', type: 'error' });
    } finally {
      setIsChangingPassword(false);
    }
  };

  // Critical error display if user details fail to load
  if (errorMessage && !currentUserDetails) {
    return <div className="profile-error-critical">{errorMessage}</div>;
  }

  return (
    <div className="profile-page-container">
      <div className="profile-main-panel">
        <div className="profile-section personal-information">
          <h2>Personal Information</h2>
          <p className="section-subtitle">
            Update your personal details.
            {currentUserDetails?.role?.name && (
              <span className="user-role-display-inline">
                Your Role: <span className="role-badge">{currentUserDetails.role.name.replace(/_/g, ' ')}</span>
              </span>
            )}
          </p>

          {errorMessage && <div className="profile-message error-message">{errorMessage}</div>}
          {successMessage && <div className="profile-message success-message">{successMessage}</div>}

          {currentUserDetails ? (
            <form onSubmit={handleSaveChanges}>
              <div className="form-group">
                <label htmlFor="fullName">Full Name</label>
                <input
                  type="text"
                  id="fullName"
                  value={fullNameInput}
                  onChange={handleFullNameChange}
                  disabled={isSaving}
                />
              </div>
              <div className="form-group">
                <label htmlFor="emailOrUsername">Email or Username</label>
                <input
                  type="text"
                  id="emailOrUsername"
                  value={currentUserDetails.email || ''}
                  readOnly
                  disabled
                  title="This value cannot be changed."
                />
                <small className="form-note">Email and Username cannot be changed.</small>
              </div>
              <button type="submit" className="profile-button profile-button-primary" disabled={isSaving}>
                {isSaving ? 'Saving...' : 'Save Changes'}
              </button>
            </form>
          ) : (
            <div className="profile-loading">Loading profile...</div>
          )}
        </div>

        {currentUserDetails && (
          <div className="profile-section personal-information" style={{ marginTop: '1.5rem' }}>
            <h2>Password</h2>
            <p className="section-subtitle">
              Change your password here, or use{' '}
              <a href={`${AUTH_APP_URL}/reset-password`} target="_blank" rel="noreferrer">
                Forgot Password
              </a>{' '}
              (email OTP verification) if you do not remember it.
            </p>
            {passwordMessage.text && (
              <div className={`profile-message ${passwordMessage.type === 'success' ? 'success-message' : 'error-message'}`}>
                {passwordMessage.text}
              </div>
            )}
            <form onSubmit={handleChangePassword}>
              <div className="form-group">
                <label htmlFor="currentPassword">Current Password</label>
                <input
                  type="password"
                  id="currentPassword"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  disabled={isChangingPassword}
                  autoComplete="current-password"
                />
              </div>
              <div className="form-group">
                <label htmlFor="newPassword">New Password</label>
                <input
                  type="password"
                  id="newPassword"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  disabled={isChangingPassword}
                  autoComplete="new-password"
                />
              </div>
              <div className="form-group">
                <label htmlFor="confirmPassword">Confirm New Password</label>
                <input
                  type="password"
                  id="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  disabled={isChangingPassword}
                  autoComplete="new-password"
                />
              </div>
              <button type="submit" className="profile-button profile-button-primary" disabled={isChangingPassword}>
                {isChangingPassword ? 'Updating...' : 'Update Password'}
              </button>
            </form>
          </div>
        )}
      </div>

      {currentUserDetails && (
        <div className="profile-sidebar-panel">
          <div className="profile-section avatar-section">
            <h3>Your Avatar</h3>
            <div className="avatar-container">
                <div className="avatar-display" title="Current Avatar">
                    {isImageLoading ? (
                         <div className="avatar-overlay">Loading...</div>
                    ) : profileImage ? (
                        <img src={profileImage} alt="Profile Avatar" className="profile-avatar-image" />
                    ) : (
                        avatarInitials || '?'
                    )}
                    {(isUploading || isDeleting) && <div className="avatar-overlay">{isUploading ? 'Uploading...' : 'Deleting...'}</div>}
                </div>
            </div>
            
            <div className="avatar-actions">
                <button
                    type="button"
                    className="avatar-action-button upload-button"
                    title="Upload New Avatar"
                    onClick={handleAvatarClick}
                    disabled={isUploading || isDeleting || isImageLoading}
                >
                    <IconUpload />
                </button>
                {/* ==================================================================== */}
                {/* ### THE DELETE BUTTON LOGIC ###                                      */}
                {/* It is disabled if `profileImageId` is null or if another action     */}
                {/* (uploading, deleting, loading) is in progress. This is the correct   */}
                {/* and safe behavior.                                                   */}
                {/* ==================================================================== */}
                <button
                    type="button"
                    className="avatar-action-button delete-button"
                    title="Remove Avatar"
                    onClick={handleRemoveAvatar}
                    disabled={!profileImageId || isUploading || isDeleting || isImageLoading}
                >
                    <IconDelete />
                </button>
            </div>

            <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileSelected}
                style={{ display: 'none' }}
                accept="image/png, image/jpeg, image/gif"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Profile;